import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
} from '@react-google-maps/api';
import geocoder from '~/config/geocoder';
import MoreInformation from '~/pages/Patients/components/DataTable/components/MoreInformation';

import { Content } from './styles';

const containerStyle = {
  width: '100%',
  height: '100%',
};

const center = {
  lat: -15.7217175,
  lng: -48.0774438,
};

export default function MapComponent({ markers, zoom }) {
  const [activeMarker, setActiveMarker] = useState(null);

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  return (
    <LoadScript loadingElement={<p />} googleMapsApiKey={geocoder.apiKey}>
      <GoogleMap
        id="map"
        onClick={() => setActiveMarker(null)}
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
      >
        {markers.map(({ lat, lng, id }, index) => (
          <Marker
            key={index}
            position={{ lat, lng }}
            onClick={() => handleActiveMarker(id)}
          >
            {activeMarker === id && (
              <InfoWindow
                onCloseClick={() => setActiveMarker(null)}
                style={{ padding: 0 }}
              >
                <Content>
                  <MoreInformation user={{ id }} />
                </Content>
              </InfoWindow>
            )}
          </Marker>
        ))}
      </GoogleMap>
    </LoadScript>
  );
}

MapComponent.propTypes = {
  markers: PropTypes.arrayOf(PropTypes.object),
  zoom: PropTypes.number,
};

MapComponent.defaultProps = {
  markers: [],
  zoom: 4,
};
